export default __webpack_public_path__ + "static/media/theme_lock_white.fa46fad2.svg";